import React from 'react';
import { CROABanner } from './CROABanner';
import { useCROABanner } from './hooks/CROABanner.hook';
import { useHistory } from 'react-router-dom';
import { usePremiumHelpers } from 'hook/premium.hook';

const CROABannerController = props => {
  const premium = usePremiumHelpers(props.eventHandler);
  const history = useHistory();
  const croaBanner = useCROABanner(
    props.userInfo,
    props.creditInfo,
    history,
    props.eventHandler,
  );

  return (
    <CROABanner
      {...croaBanner}
      userInfo={props.userInfo}
      creditInfo={props.creditInfo}
      eventHandler={props.eventHandler}
      premium={premium}
    />
  );
};

export default CROABannerController;
